import { useSelector } from 'react-redux'
import { useNavigate, useParams } from 'react-router-dom'
import { PunchListViewOptions, searchTermLocalStorageKey, assignationFilterLocalStorageKey } from '../../../../Constants/Consts'
import { RootState } from '../../../../store/store'
import { PunchlistApiType } from "../../../../types/PunchList/PunchListSchema.ts";
import StatusTextIcon from '../../../../components/CoreComponents/StatusTextIcons.tsx'
import { twMerge } from "tailwind-merge";
import SectionHeader from '../../../../components/CoreComponents/Details/SectionHeader.tsx';
import { useEffect, useMemo, useState } from 'react';
import SearchComponent from '../../../../components/CoreComponents/Search.tsx';
import PunchlistTable from './Table/Table.tsx';
import { getLocalStorageItem, removeLocalStorageItem, setLocalStorageItem } from '../../../../Helpers/Functions.ts';


const FilterationKeys = {
    assignedDisciplineId: "assignedDisciplineId",
    creatorDisciplineId: "creatorDisciplineId"
}
export default function View() {
    const { disciplineId } = useParams()
    let { viewType } = useParams();
    viewType = viewType || (disciplineId ? PunchListViewOptions.DISCIPLINE.name : viewType);
    const [assignationFilter, setAssignationFilter] = useState(() => {
        const cached = getLocalStorageItem<string>(assignationFilterLocalStorageKey);
        return cached === FilterationKeys.creatorDisciplineId ? cached : FilterationKeys.assignedDisciplineId;
    })
    const navigate = useNavigate()
    const { allDisciplines: disciplines } = useSelector((state: RootState) => state.Discipline)
    const selectedDiscipline = disciplines.find(d => String(d.disciplineId) == disciplineId)
    const { ProjectPunchLists } = useSelector((state: RootState) => state.PunchList)
    const { SelectedUser } = useSelector((state: RootState) => state.SelectedUser);

    const [searchTerm, setSearchTerm] = useState(() => {
        const cashed = getLocalStorageItem<string>(searchTermLocalStorageKey);
        return cashed ?? "";
    });

    const isSearrchTermCached = searchTerm.length !== 0 ? searchTerm : undefined


    const filteredPunchLists: PunchlistApiType[] = [];
    let headerTitle: string;
    const disciplinView = viewType === PunchListViewOptions.DISCIPLINE.name && !!disciplineId

    if (disciplinView) {
        filteredPunchLists.push(...ProjectPunchLists.filter(pl => Number(pl[assignationFilter]) === Number(disciplineId)))
        headerTitle = selectedDiscipline.disciplineName;
    } else if (viewType === PunchListViewOptions.ALL_PUNCH_LISTS.name) {
        filteredPunchLists.push(...ProjectPunchLists)
        headerTitle = PunchListViewOptions.ALL_PUNCH_LISTS.label;
    } else if (viewType === PunchListViewOptions.MY_PUNCH_LISTS.name) {
        filteredPunchLists.push(...ProjectPunchLists.filter(pl => pl.identifiedBy === SelectedUser.email || pl.identifiedBy === SelectedUser.kionEmail))
        headerTitle = PunchListViewOptions.MY_PUNCH_LISTS.label;
    } else if (viewType === PunchListViewOptions.ERM_RELEVANT.name) {
        filteredPunchLists.push(...ProjectPunchLists.filter(pl => pl.ermRelevant));
        headerTitle = PunchListViewOptions.ERM_RELEVANT.label;
    }

    useEffect(() => {
        if (searchTerm.length === 0) removeLocalStorageItem(searchTermLocalStorageKey);
    }, [searchTerm])

    // Clear search when switching between view types or disciplines
    useEffect(() => {
        setSearchTerm("");
        removeLocalStorageItem(searchTermLocalStorageKey);
    }, [viewType, disciplineId])

    // Clear search when leaving the page
    useEffect(() => {
        return () => {
            removeLocalStorageItem(searchTermLocalStorageKey);
        };
    }, [])

    const groupedPunchlistsByStatus = filteredPunchLists?.reduce((g, p) => {
        const key = p.statusId
        if (!g[key]) g[key] = []
        g[key].push(p)
        return g
    }, {})

    const customOrder = [11, 6, 4, 9, 8, 10, 7, 12];
    const sortedStatusKeys = Object.keys(groupedPunchlistsByStatus ?? {}).sort((a, b) => {
        let indexA = customOrder.indexOf(Number(a));
        let indexB = customOrder.indexOf(Number(b));
        return indexA - indexB;
    });
    const assignation = assignationFilter === FilterationKeys.assignedDisciplineId ? "Assigned To" : "Created By";
    const toggleSwitch = () => {
        setAssignationFilter(oldAssignation => {
            const next = oldAssignation === FilterationKeys.assignedDisciplineId ? FilterationKeys.creatorDisciplineId : FilterationKeys.assignedDisciplineId;
            setLocalStorageItem(assignationFilterLocalStorageKey, next);
            return next;
        });
    }

    const handleSearch = (searchTerm: string) => {
        setSearchTerm(searchTerm);
        setLocalStorageItem(searchTermLocalStorageKey, searchTerm)
    }


    const filteredProjectPunchLists = useMemo(() => ProjectPunchLists.filter(pl => {
        const searchTermLower = searchTerm.toLowerCase();
        return pl.punchListUuid?.slice(0, 8)?.toLowerCase().includes(searchTermLower) ||
            pl.punchListTag?.toLowerCase().includes(searchTermLower)
    }
    ), [searchTerm]);


    const isSearchTermValid = searchTerm.length > 0

    return <div className={isSearchTermValid ? 'max-w' : 'max-w-4xl'}>
        <div className="flex justify-between items-center mb-4">
            <div className="flex-grow mr-4">
                <SearchComponent 
                    key={`${viewType}-${disciplineId}`}
                    onSearch={handleSearch} 
                    autoComplete='off' 
                    isSearchTermCached={isSearrchTermCached} 
                />
            </div>
        </div>
        {isSearchTermValid ? <PunchlistTable filteredProjectPunchLists={filteredProjectPunchLists} /> : <>
            <div className={twMerge(`flex gap-3 items-center mt-4 mb-4 justify-between`)}>
                <SectionHeader title={`${disciplinView ? assignation : ""} ${headerTitle}`} />

                {disciplinView &&
                    <div className="flex items-center">
                        {/* <span className="ml-3 font-medium text-gray-900">Switch Assignment:</span> */}
                        <span className="ml-2 mr-2 text-sm text-black dark:text-white">Assigned To</span>
                        <div
                            className={`w-12 h-6 flex items-center bg-gray-300 rounded-full p-1 cursor-pointer ${assignation === "Created By" ? "bg-orange-1000" : "bg-gray-200"
                                }`}
                            onClick={toggleSwitch}
                            role="switch"
                            aria-checked={assignation === "Created By"}

                        >
                            <div
                                className={`bg-white w-4 h-4 rounded-full shadow-md transform transition-transform ${assignation === "Created By" ? "translate-x-6" : "translate-x-0"}`} />
                        </div>
                        <span className="ml-2 text-sm text-black dark:text-white">Created By</span>
                    </div>
                }
            </div>
            <hr className="border-t mt-2" />

            <ul>
                {sortedStatusKeys.map((k, i, arr) => {
                    return (
                        <li
                            className={`flex items-center py-4 cursor-pointer text-sm hover:bg-orange-1000 hover:text-white hover:cursor-pointer border-b ${i !== arr.length - 1 ? 'border-gray-300' : 'border-0'}`}
                            onClick={() => viewType === PunchListViewOptions.DISCIPLINE.name ?
                                navigate(`/PunchListDiscipline/${disciplineId}/view/${k}/${assignationFilter}`) :
                                navigate(`/PunchList/${viewType}/view/${k}`)
                            }
                            key={k}
                        >
                            <StatusTextIcon statusId={Number(k)} />
                            <span className="ml-2">- Total: {groupedPunchlistsByStatus[k].length}</span>
                        </li>
                    );
                })}
            </ul>
        </>}
    </div>


}
